import { AccordionItem, Heading } from '@mm/components';
import { MonitorIcon, SmartphoneIcon } from '@mm/icons';
import { PageBillingType } from '@mm/state/interfaces/connected-page';
import classNames from 'classnames';
import React, { useState } from 'react';
import { RequiredPlanBadge } from '../../../../../../common/components/ProBadge';
import { ChannelIcon } from '../../../../liveChat/components/ChannelIcon';
import './CustomerChatEditorAccordionItem.pcss';

type Props = {
  children: React.ReactNode | React.ReactNode[];
  title: string | JSX.Element;
  descriptionText?: string;
  facebook?: boolean;
  webchat?: boolean;
  desktop?: boolean;
  mobile?: boolean;
  billingType?: PageBillingType;
  openOnMount?: boolean;
  usedInSlideout?: boolean;
};

export const CustomerChatEditorAccordionItem = ({
  children,
  title,
  descriptionText,
  facebook,
  webchat,
  desktop,
  mobile,
  billingType,
  openOnMount,
  usedInSlideout,
}: Props) => {
  const [isOpen, setIsOpen] = useState(!!openOnMount);
  const className = classNames('customer-chat-editor-accordion-item', {
    'customer-chat-editor-accordion-item--open': isOpen && !usedInSlideout,
    'customer-chat-editor-accordion-item--open--slideout':
      isOpen && usedInSlideout,
    'customer-chat-editor-accordion-item--slideout': usedInSlideout,
  });
  return (
    <AccordionItem
      className={className}
      arrowClassName={classNames('customer-chat-editor-accordion-item__arrow', {
        'customer-chat-editor-accordion-item__arrow--slideout': usedInSlideout,
      })}
      descriptionClassName={
        usedInSlideout
          ? 'customer-chat-editor-accordion-item__description--slideout'
          : 'customer-chat-editor-accordion-item__description'
      }
      arrowPosition="left"
      openOnMount={openOnMount}
      onToggle={setIsOpen}
      closeOnOutsideClick={false}
      withBorder={!usedInSlideout}
      childrenWrapperClassName={
        usedInSlideout
          ? 'customer-chat-editor-accordion-item__children-container--slideout'
          : ''
      }
      headerWrapperClassName={
        usedInSlideout && isOpen
          ? 'customer-chat-editor-accordion-item__header-wrapper-opened--slideout'
          : ''
      }
      titleComponent={
        <div className="customer-chat-editor-accordion-item__title">
          {typeof title === 'string' ? (
            <Heading
              className={
                usedInSlideout
                  ? 'customer-chat-editor-accordion-item__heading-slideout'
                  : 'customer-chat-editor-accordion-item__heading'
              }
              size={4}
              text={title}
            />
          ) : (
            <>{title}</>
          )}
          {billingType && (
            <RequiredPlanBadge
              className="customer-chat-editor-accordion-item__badge"
              billingType={billingType}
            />
          )}
        </div>
      }
      description={
        <>
          {facebook && (
            <ChannelIcon
              className="customer-chat-editor-accordion-item__channel-icon"
              channel="facebook"
            />
          )}
          {webchat && (
            <ChannelIcon
              className="customer-chat-editor-accordion-item__channel-icon"
              channel="webchat"
            />
          )}
          {desktop && (
            <MonitorIcon className="customer-chat-editor-accordion-item__platform-icon" />
          )}
          {mobile && (
            <SmartphoneIcon className="customer-chat-editor-accordion-item__platform-icon" />
          )}

          {descriptionText && <span>{descriptionText}</span>}
        </>
      }
    >
      {children}
    </AccordionItem>
  );
};
